export enum ServiceName {
  ContactTypes = 'contactTypes',
  PasswordExpirationTypes = 'passwordExpirationTypes',
  States = 'states',
  Countries = 'countries',
  TimeZones = 'timeZones',
  DateFormats = 'dateFormats',
  NumberFormats = 'numberFormats',
  Languages = 'languages',
  TimeFormats = 'timeFormats',
  WeightUnits = 'weightUnits',

}

export enum ServiceCode {
  ContactTypes = 'Contact_Type_Cd',
  CustomerSettings = 'Customer_Setting_Type_Cd',
  States = 'State_Cd',
  Countries = "Country_Cd",
  TimeZones = 'Time_Zone_Cd',
  DateFormats = 'Date_Format_Cd',
  NumberFormats = 'Number_Format_Cd',
  Languages = 'Language_Cd',
  TimeFormats = 'Time_Format_Cd',
  WeightUnits = 'Weight_Unit_Cd',
  AssociatedClinics = 'associated-clinics',
  PasswordExpirationTypes = 'Password_Expiry_Cd',
}

export enum Mode {
  Create = 'create',
  Edit = 'edit',
  View = 'view',
  Delete = 'delete',
}

export enum AlertTypes {
  OfficeAlertTypes = 'officeAlerts',
  MedicalAlertTypes = 'medicalAlerts'
}

export enum HoursErrMessages {
  cs816Label = 'msg.cs816.text',
  cs813Label = 'msg.cs813a.text',
  cs818Label = 'msg.cs818.text',
  errHeading = "Please correct the following fields marked in red below.",
  reqHeading = "The following fields are required:",
  endTimeErrMsg = "The time range entered is invalid. The Closing Time can't be earlier than Opening Time. Please re-enter the Opening Time, Closing Time range again.",
  // mondayOpen = "Monday Opening Time",
  // mondayClose = "Monday Closing Time",
  // tuesdayOpen = "Tuesday Opening Time",
  // tuesdayClose = "Tuesday Closing Time",
  // wednesdayOpen = "Wednesday Opening Time",
  // wednesdayClose = "Wednesday Closing Time",
  // thursdayOpen = "Thursday Opening Time",
  // thursdayClose = "Thursday Closing Time",
  // fridayOpen = "Friday Opening Time",
  // fridayClose = "Friday Closing Time",
  // saturdayOpen = "Saturday Opening Time",
  // saturdayClose = "Saturday Closing Time",
  // sundayOpen = "Sunday Opening Time",
  // sundayClose = "Sunday Closing Time",
  // holidayName = "Holiday name",
  holidayName = 'label.gb.holiday_name',

  dateField = "label.gb.out_of_office <br> label.gb.back_in_office",
  dateField2 = "label.gb.out_of_office <br> label.gb.back_in_office",
  
  dateField3 = "label.gb.holiday_name <br> label.gb.out_of_office",
  dateField4 = "label.gb.holiday_name <br> label.gb.back_in_office",
  allEmptyField = "label.gb.holiday_name <br> label.gb.out_of_office <br> label.gb.back_in_office",
  // OutOffOfc = "Out of office",
  OutOffOfc = 'label.gb.out_of_office', 

  // HolidayName = "Holiday name",
  HolidayName = 'label.gb.holiday_name',

  // BackToOfc = "Back in office"
  BackToOfc = 'label.gb.back_in_office',

}